module.exports = __webpack_public_path__ + "static/media/banner-garantia-mobile.c89adda2.webp";